import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';

export const transformBackendEndpoint = (uri: string, currentSourceDomain: SourceDomain) => {
  const matchedSourceDomain = Object.values(SourceDomain).find(sourceDomain => uri?.includes(sourceDomain));
  return matchedSourceDomain ? uri?.replace(matchedSourceDomain, currentSourceDomain) : uri;
};
